import React from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import { MapPinned } from "lucide-react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const stores = [
  {
    name: "Khatipura",
    address:
      "17, Behind Maharaja Complex, Khatipura, Indore, Madhya Pradesh - 452007",
    position: [22.7318, 75.8549],
  },
  {
    name: "Old Palasia",
    address:
      "1B, Ground Floor, The Mark, 20-A, Anand Bazar Road, Opposite Rafael Tower, Old Palasia, Indore, Madhya Pradesh - 452001",
    position: [22.7278, 75.8871],
  },
  {
    name: "Vijay Nagar",
    address:
      "PU-4, Opposite Prestige College, Near Bombay Hospital, Scheme No. 54, Vijay Nagar, Indore, Madhya Pradesh - 452010",
    position: [22.7535, 75.8943],
  },
  {
    name: "Annapurna Road",
    address:
      "2, Annapurna Road, Opposite Dussehra Maidan, Bank Colony, Indore, Madhya Pradesh - 452009",
    position: [22.6945, 75.8349],
  },
  {
    name: "Scheme No. 140",
    address:
      "Shop No. 8, No. 09, RCM Block, Shanti Dazzle, Near Agrawal Public School, Scheme No. 140, Indore, Madhya Pradesh - 452016",
    position: [22.7039, 75.9258],
  },
];

const phoneNumber = "+919539188888";
const googleMapsUrl =
  "https://www.google.com/maps/search/?api=1&query=Shree%20Prem%20Cosmetics%2C%20Indore%2C%20Madhya%20Pradesh";
const markerIcon = L.divIcon({
  className: "border-0 bg-transparent",
  html: '<span style="display:flex;align-items:center;justify-content:center;width:34px;height:34px;border:3px solid #ffffff;border-radius:50% 50% 50% 0;background:#ef4444;box-shadow:0 3px 8px rgba(0,0,0,.28);color:#ffffff;font:600 9px Arial,sans-serif;transform:rotate(-45deg)"><span style="transform:rotate(45deg)">SPC</span></span>',
  iconSize: [34, 42],
  iconAnchor: [17, 34],
  popupAnchor: [0, -34],
});

const LocationController = () => {
  const map = useMap();

  React.useEffect(() => {
    const locateStore = () => {
      if (navigator.geolocation) {
        map.locate({ setView: true, maxZoom: 14 });
      }
    };

    window.addEventListener("spc:locate-store", locateStore);
    return () => window.removeEventListener("spc:locate-store", locateStore);
  }, [map]);

  return null;
};

const VisitStore = () => {
  return (
    <div id="store-map" className="bg-[#f5eaea] py-20 px-8 flex justify-center">
      <div className="max-w-7xl w-full flex flex-col lg:flex-row items-center">
        <div className="lg:w-1/3 w-full text-left">
          <h2 className="text-5xl font-semibold text-gray-800 leading-tight">
            <span className="block">Visit your</span>
            <span className="block">nearest store</span>
          </h2>
          <p className="text-lg text-gray-600 mt-4 sm:block">
            <span className="block italic">Enhanced shopping</span>
            <span className="block italic">experience at the store</span>
          </p>
        </div>

        <div className="relative lg:w-2/3 w-full mt-12 lg:mt-10">
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute right-3 top-3 z-[1000] inline-flex items-center gap-2 rounded-md border border-[#d93025] bg-white px-4 py-2 text-sm font-medium text-[#d93025] shadow-md transition-colors hover:bg-[#d93025] hover:text-white"
          >
            <MapPinned aria-hidden="true" size={16} />
            Open in Google Maps
          </a>
          <MapContainer
            center={[22.7196, 75.8577]}
            zoom={11}
            scrollWheelZoom={false}
            className="w-full h-[450px] border-0 z-0"
            style={{ height: "450px", width: "100%" }}
            aria-label="Map showing all five Shree Prem Cosmetics branches in Indore"
          >
            <LocationController />
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {stores.map((store) => (
              <Marker key={store.name} position={store.position} icon={markerIcon}>
                <Popup>
                  <div className="min-w-[210px] p-1">
                    <strong className="text-sm text-gray-900">{store.name}</strong>
                    <p className="mt-1 text-xs leading-5 text-gray-600">{store.address}</p>
                    <div className="mt-2 flex items-center gap-3 text-xs">
                      <a className="font-medium text-red-500" href={`tel:${phoneNumber}`}>
                        +91 95391 88888
                      </a>
                      <a
                        className="font-medium text-red-500"
                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                          `${store.address}, India`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Directions
                      </a>
                    </div>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default VisitStore;
